import {
  Book,
  BookA,
  BookCopy,
  BookDashed,
  BookHeart,
  EllipsisVertical,
  Globe,
  Globe2,
  Play,
  ShoppingCart,
  Star,
} from "lucide-react";

import { Button } from "../../../components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../components/ui/dropdown-menu";
import { cn } from "../../../lib/utils";
import { API_BASE_URL } from "../../../lib/constants";
import { Skeleton } from "../../../components/ui/skeleton";

export function SentenceDropdown({ isHighlighted, title, book, playAudio }) {
  const wikiUrl = `https://en.wikipedia.org/wiki/${
    title || "".replace("(Audio)", "").trim()
  }_language`;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="outline"
          className={cn(
            "absolute right-4 z-30 bg-transparent text-gray-600 border-gray-100 shadow-sm",
            isHighlighted ? "bg-gray-100/90" : "bg-gray-50"
          )}
        >
          <EllipsisVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-56 rounded-xl overflow-hidden"
      >
        <DropdownMenuLabel className="flex justify-between">
          {title}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          {wikiUrl && (
            <DropdownMenuItem
              onSelect={() => {
                window.open(wikiUrl, "_blank");
              }}
            >
              <Globe2 />
              <span>Wiki</span>
            </DropdownMenuItem>
          )}
          {playAudio && (
            <DropdownMenuItem onSelect={playAudio}>
              <Play />
              <span>Play Audio</span>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem
            onSelect={() => {
              window.open(book?.amazon_url, "_blank");
            }}
          >
            <ShoppingCart />
            <span>Purchase on Amazon</span>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="group"
            onClick={() => {
              window.open(book?.amazon_url, "_blank");
            }}
          >
            <a
              href={book?.amazon_url}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-4 w-full justify-between"
            >
              <span className="flex-1 flex flex-col items-center">
                <BookHeart
                  className="text-gray-300 transition-colors duration-200 group-hover:text-gray-400"
                  height={24}
                  width={24}
                />{" "}
              </span>
              {book ? (
                <img
                  src={API_BASE_URL + "/phrasebooks/" + book?.cover_image}
                  className="h-auto w-32 bg-gray-200 rounded-xl"
                  alt="cover"
                />
              ) : (
                <Skeleton
                  className={"h-24 w-[200px] rounded-xl bg-gray-200"}
                ></Skeleton>
              )}
            </a>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
